exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.MinMax__minmax__eCU9u {\n  display: inline-block;\n  width: 100%; }\n  .MinMax__minmax__eCU9u.MinMax__home__290Y9 {\n    margin: -2px 0 30px 0; }\n    @media (min-width: 992px) {\n      .MinMax__minmax__eCU9u.MinMax__home__290Y9 {\n        margin-bottom: 20px; } }\n  .MinMax__minmax__eCU9u p {\n    font-size: 11px;\n    color: #9c9c9c;\n    float: left;\n    margin: 3px 15px 0 0; }\n    @media (min-width: 768px) and (max-width: 992px) {\n      .MinMax__minmax__eCU9u p {\n        margin-right: 15px; } }\n    @media (min-width: 992px) {\n      .MinMax__minmax__eCU9u p {\n        margin-right: 30px; } }\n    .MinMax__minmax__eCU9u p:last-child {\n      margin-right: 0; }\n", ""]);

// exports
exports.locals = {
	"minmax": "MinMax__minmax__eCU9u",
	"home": "MinMax__home__290Y9"
};